module.exports = __webpack_public_path__ + "assets/img/d88c-ly.svg";